import analytic from './analytic';
import charts from './charts';
import profiles from './profiles';
import artist from './artist';
import search from './search';
import album from './album';
import track from './track';
import playlist from './playlist';
import live from './live';
import deliveryMonitoring from './deliveryMonitoring';
import user from './user';

export default {
	analytic,
	charts,
	profiles,
	artist,
	search,
	album,
	track,
	playlist,
	live,
	deliveryMonitoring,
	user,
};
